<template>
    <div class="banner-image-area position-relative">
        <div class="container_fl">
            <div class="row align-items-center banner-width">
                <div class="col-lg-3 wow move-up" v-if="!fullWidth"></div>
                <div class="wow move-up" :class="fullWidth ? 'col-lg-12' : 'col-lg-6'">
                    <div class="banner-image__content">
                        <div class="section-title-wrapper content-section-title">
                            <h3 class="section-title font-weight--light"><slot name="header"></slot></h3>
                        </div>
                        <div class="banner-image__text section-space--mb_40 content-section">
                            <slot name="main"></slot>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 wow move-up" v-if="!fullWidth"></div>
            </div>
        </div>
    </div>
</template>

<style>
.content-section h4 {
    font-size: 20px;
    font-weight: 500;
}
</style>

<script>
export default {
    name: 'ContentSection',

    props: {
        fullWidth: {
            type: Boolean,
            default: false
        }
    }
};
</script>
